/* eslint-disable no-unused-vars */
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Transfer, Modal, Button, Space, ConfigProvider } from 'antd'
import type { TransferDirection } from 'antd/es/transfer'
import zhCN from 'antd/es/locale/zh_CN'
import { useTranslation } from 'react-i18next'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { IBu } from '@/store/models/auth.model'
import { relevantGetById } from '@/services/progress.service'

function SelectRelevant ({
    show, setShow, confirm, title, id, judgesType, selectedKeysData,isSecondProposal
}: {
    show: boolean
    setShow: (b: boolean) => void
    confirm: (users: IBu[]) => void
    title: string
    id: number
    isSecondProposal: boolean,
    selectedKeysData: string[],
    judgesType: number // 1 评审人员 2 旁听人员
}): ReactElement {
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const [targetKeys, setTargetKeys] = useState<string[]>([])
    const [selectedKeys, setSelectedKeys] = useState<string[]>([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [userLs, setUserLs] = useState<any[]>([])
    useEffect(() => {
        setTargetKeys(selectedKeysData)
    }, [selectedKeysData])

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const onChange = (nextTargetKeys: string[], direction: TransferDirection, moveKeys: string[]) => {
        setTargetKeys(nextTargetKeys)
    }

    const onSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
    }
    const onConfirm = () => {
        const res = userLs.filter(item => targetKeys.includes(item.id.toString()))
        confirm(res)
        closePop()
    }
    const closePop = () => {
        setShow(false)
    }

    const getUserLs = async () => {
        try {
            const res = await relevantGetById(id)
            let ls: any[] = []
            res.forEach(item => {
                ls = ls.concat([...item.tmtInfos.filter((subItem: any) => {
                    if(isSecondProposal){
                        return subItem.judgesType === judgesType  && subItem?.isParticipate === true
                    }else{
                        return judgesType === subItem.judgesType
                    }
                    
                })])
            })
            setUserLs(ls)
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    useEffect(() => {
        getUserLs()
    }, [])

    useEffect(() => {
        setIsModalOpen(show)
    }, [show])

    return (
        (<Modal title={title} open={isModalOpen} 
            onOk={closePop}
            onCancel={closePop}
            width='90%'
            centered
            footer={[
                <Button key="confirm" type="primary" onClick={onConfirm}>{t('confirm')}</Button>,
                <Button key="close" onClick={closePop}>{t('close')}</Button>
            ]}
        >
            <Space direction='vertical' style={{ width: '100%' }}>
                <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
                    <Transfer
                        style={{ width: '100%' }}
                        listStyle={{ flex: 1 }}
                        dataSource={userLs}
                        showSearch
                        titles={[t('Source'), t('Target')]}
                        rowKey={record => '' + record.id}
                        targetKeys={targetKeys}
                        selectedKeys={selectedKeys}
                        onChange={onChange}
                        onSelectChange={onSelectChange}
                        render={item => item.tmtFullUser}
                    />
                </ConfigProvider>
            </Space>
        </Modal>)
    );
}

export default SelectRelevant
